import cn from "classnames";
import React, { type FC } from "react";
import { Icon } from "semantic-ui-react";
import styles from "./embeddedVideosNoResults.module.scss";
import NoResultsWithButton from "components/noResultsWithButton/NoResultsWithButton";

export interface EmbeddedVideosNoResultsProps {
  createButton?: React.ReactElement | null;
  filtered?: boolean;
  title?: string;
  description?: string;
}

const EmbeddedVideosNoResults: FC<EmbeddedVideosNoResultsProps> = ({ createButton, filtered, title, description }) => {
  return (
    <NoResultsWithButton
      title={title || "You don't have any Embedded Videos"}
      description={description || "Looks like you don't have any Embedded Videos yet."}
      actionText="the button below to get started."
      icon={<Icon className={cn("fa-video", styles.videoIcon)} />}
      actionButton={createButton}
      filtered={filtered}
    />
  );
};

export default EmbeddedVideosNoResults;
